import { BackendModule } from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { BUILD_VERSION, PATIENT_APP_URL } from '../constants';

export const l10nFromBackendModule = (): BackendModule => {
  return new HttpBackend(null, {
    loadPath: `${PATIENT_APP_URL}/dictionaries/{{ns}}.{{lng}}.json`,
    addPath: `${PATIENT_APP_URL}/add/{{lng}}`,
    crossDomain: true,
    queryStringParams: { v: BUILD_VERSION },
  });
};
